import type { AlertProps } from "@mui/material"
import { Alert, AlertTitle } from "@mui/material"
import { WarningOutlined } from "@mui-symbols-material/w300"
import React from "react"
import { twMerge } from "tailwind-merge"

export interface InformationMissingAlertProps extends Omit<AlertProps, "title"> {
  title?: string
  description?: string
  titleClassName?: string
}

export const InformationMissingAlert = React.forwardRef<HTMLDivElement, InformationMissingAlertProps>(
  ({ title, description, children, className, titleClassName, icon, ...alertProps }, ref) => {
    return (
      <Alert
        variant='filled'
        severity='info'
        className={className}
        ref={ref}
        icon={icon ?? <WarningOutlined color='primary' />}
        {...alertProps}
      >
        {Boolean(title) && <AlertTitle className={twMerge("text-gray-900", titleClassName)}>{title}</AlertTitle>}
        {Boolean(description) && (
          <p className={twMerge("text-sm text-blue-gray-600", Boolean(children) && "mb-3")}>{description}</p>
        )}
        {children}
      </Alert>
    )
  }
)
